import React from 'react'
import { formatSellablePricing, getSellableUrl } from '#src/services/sellable'
import { Link } from 'react-scroll'
import styles from './styles.css'
import { ActivityFeedSellableFragment } from '#src/generated/graphql'
import { Image } from '@deal/components'
import PurchasedIcon from './purchased.svg'

interface Props {
  sellable: ActivityFeedSellableFragment
}

const VerifiedPurchaseCard: React.SFC<Props> = ({ sellable }) => {
  const sellableImage = sellable.images.length > 0 ? sellable.images[0] : ''
  const sellablePricing = formatSellablePricing(sellable, {
    percentSavingsDisplayThreshold: 5
  })

  if (!sellableImage) {
    return null
  }

  return (
    <div className={styles.reviewSellable} key={sellable.id}>
      <span className={styles.purchased}>
        <PurchasedIcon className={styles.purchasedIcon} /> Purchased
      </span>
      <Link to={getSellableUrl(sellable)} className={styles.link}>
        <div className={styles.sellableImage}>
          <Image
            src={sellableImage.url}
            width={164}
            height={164}
            imgixParams={{
              fit: 'crop',
              h: '164',
              w: '164'
            }}
          />
        </div>
        <div className={styles.sellableDetails}>
          <div className={styles.sellableTitle}>{sellable.title}</div>
          {sellablePricing && (
            <div className={styles.sellablePrice}>
              <div className={styles.sellablePriceValue}>
                <strong>{sellablePricing.price}</strong>
                {sellablePricing.msrp && `was ${sellablePricing.msrp}`}
              </div>
              {sellablePricing.savingsPercentage && (
                <div className={styles.sellablePriceDiscount}>
                  {sellablePricing.savingsPercentage} off
                </div>
              )}
            </div>
          )}
        </div>
      </Link>
    </div>
  )
}

export default VerifiedPurchaseCard
